// landing.js – helpers for metafield-driven landing pages

document.addEventListener('DOMContentLoaded', function () {
  // Flag CSS that landing JS is active
  document.documentElement.classList.add('has-landing-js');

  var landingRoot = document.querySelector('.landing-wrapper');
  if (!landingRoot) return;

  // ------------------------------------------
  // Smooth scroll enkuriem landing lapā
  // ------------------------------------------
  landingRoot.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || href === '#') return;

    var targetId = href.slice(1);
    var targetEl = document.getElementById(targetId);
    if (!targetEl) return;

    event.preventDefault();

    var headerOffset = 80; // pielāgo, ja ir sticky header
    var rect = targetEl.getBoundingClientRect();
    var offsetTop = rect.top + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth'
    });
  });

  // ------------------------------------------
  // Neliels fade-in efekts landing sekcijām
  // ------------------------------------------
  if ('IntersectionObserver' in window) {
    var sections = document.querySelectorAll(
      '.landing-wrapper > section, .landing-feature, .testimonial-card'
    );

    sections.forEach(function (el) {
      el.classList.add('is-before-visible');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    sections.forEach(function (el) {
      observer.observe(el);
    });
  }
});